/* eslint arrow-body-style: "off" */
import React, { Component } from 'react';

import Carousel3D from './Carousel3D';

const items = [
  { text: 1, url: 'https://loremflickr.com/800/600?lock=1' },
  { text: 2, url: 'https://loremflickr.com/800/600?lock=2' },
  { text: 3, url: 'https://loremflickr.com/800/600?lock=3' },
  { text: 4, url: 'https://loremflickr.com/800/600?lock=4' },
  { text: 5, url: 'https://loremflickr.com/800/600?lock=5' },
  { text: 6, url: 'https://loremflickr.com/800/600?lock=6' },
  { text: 7, url: 'https://loremflickr.com/800/600?lock=7' },
  { text: 8, url: 'https://loremflickr.com/800/600?lock=8' },
  { text: 9, url: 'https://loremflickr.com/800/600?lock=9' },
  { text: 10, url: 'https://loremflickr.com/800/600?lock=10' },
  { text: 11, url: 'https://loremflickr.com/800/600?lock=11' },
  { text: 12, url: 'https://loremflickr.com/800/600?lock=12' },
];

const gridStyleFromCoords = ({ topLeft = '1,1', bottomRight = '1,1' }) => {
  const gridColumnStart = `${topLeft},1,1`.split(',')[0];
  const gridRowStart = `${topLeft},1,1`.split(',')[1];
  const gridColumnEnd = `${bottomRight},1,1`.split(',')[0];
  const gridRowEnd = `${bottomRight},1,1`.split(',')[1];
  return {
    gridColumnStart,
    gridRowStart,
    gridColumnEnd,
    gridRowEnd,
  }
};

class Lab extends Component {
  constructor(props) {
    super(props);
    const orientation = 'horizontal';
    this.state = {
      orientation,
    };
    // this.carousel = React.createRef(); React 16 ?
    this.setCarouselRef = (element) => {
      this.carousel = element;
    };
  }

  onOrientationChange(event) {
    const orientation = event.target.value;
    this.setState({ orientation });
  }

  render() {
    const columns = 12;
    const rows = 20;
    const gridStyle = {
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gridTemplateRows: `repeat(${rows}, 1fr)`,
      height: '100vh',
      minHeight: '100vh',
      width: '100vw',
      minWidth: '100vw',
    };

    return (
      <div className="grid h-full min-h-full bg-black" style={gridStyle}>
        <div className="bg-red-600" style={gridStyleFromCoords({ topLeft: '1,1', bottomRight: '13,8' })}>
          A
        </div>
        <div className="bg-red-500" style={gridStyleFromCoords({ topLeft: '1,8', bottomRight: '5,11' })}>
          B
        </div>
        <div className="bg-blue-400" style={gridStyleFromCoords({ topLeft: '5,8', bottomRight: '9,11' })}>
          C
        </div>
        <div className="bg-red-300" style={gridStyleFromCoords({ topLeft: '9,8', bottomRight: '13,11' })}>
          D
        </div>
      </div>
    );
  }
}

export {
  Lab,
};



// WEBPACK FOOTER //
// ./src/lab/components/index.js